import { HDM_PAGE_VIEW_EVENT, NOT_APPLICABLE } from '@/data/constants/gtm';
import { GA4PageViewInfoEvent } from 'presentation/events/types/ga4Types';
import {
	getUserBrowser,
	getUserDateTime,
	getUserDevice,
	getUserOS,
	safeDecodeUrl,
} from 'presentation/events/utils/ga4Utils';

export type BuildGA4PageViewEventPayloadProps = {
	shopCity: string | null;
	shopState: string | null;
	shopName: string | null;
	isLoggedIn: boolean;
	referrer: string | null;
	userId: string | null;
};

export const buildGA4PageViewEventPayload = ({
	shopCity,
	shopState,
	shopName,
	isLoggedIn,
	referrer,
	userId,
}: BuildGA4PageViewEventPayloadProps): GA4PageViewInfoEvent => {
	const dateInfo = getUserDateTime();

	return {
		event: HDM_PAGE_VIEW_EVENT,
		page_actual_domain:
			typeof window !== 'undefined' ? safeDecodeUrl(window.location.origin) : NOT_APPLICABLE,
		page_user_came: referrer || NOT_APPLICABLE,
		page_actual_path:
			typeof window !== 'undefined'
				? safeDecodeUrl(window.location.pathname + window.location.search)
				: NOT_APPLICABLE,
		user_weekday: dateInfo.weekDay,
		user_monthday: dateInfo.monthDay,
		user_time: dateInfo.time,
		user_browser: getUserBrowser(),
		user_device: getUserDevice(),
		user_os: getUserOS(),
		user_id: (isLoggedIn && userId) || undefined,
		user_status_login: isLoggedIn,
		actual_shop_city: shopCity || NOT_APPLICABLE,
		actual_shop_state: shopState || NOT_APPLICABLE,
		actual_shop_name: shopName || NOT_APPLICABLE,
	};
};
